<script setup>
import { ref, computed, onMounted } from "vue";
import { useBookingStore } from "@stores/BookingStore"; // Adjust path if necessary

const bookingStore = useBookingStore();

onMounted(() => {
  // This will run once when the main booking app component is mounted.
  // It handles the case where a user lands directly on any /booking/* route.
  bookingStore.loadBookingFromLocalStorage();
  bookingStore.loadQueryFromURL();
});
</script>

<template>
  <router-view :key="$route.fullPath"> </router-view>
</template>

<style scoped lang="scss"></style>
